import { useNavigate } from "react-router-dom";
import Button from "../../components/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestion } from "@fortawesome/free-solid-svg-icons";

export default function RegisterModal({handleClick}) {
  let navigate = useNavigate();
  const handlePayment = () => {
    navigate("/payment");
  };
  return (
    <div className="z-1 bg-dark/20 top-0 left-0 overscroll-none absolute w-full h-full">
      <div className=" w-[50%] m-auto h-[50%] bg-white rounded-lg p-20 mt-28">
        <div className="w-[50%] m-auto text-center mb-10">
          <FontAwesomeIcon
            icon={faQuestion}
            size="2xl"
            className="w-20 h-20 text-primary"
          />
        </div>
        <p className="font-bold text-xl ">
          Would you like to provide your details to facilitate easier patronage
          during your future visits?
        </p>
        <div className="flex gap-4 justify-between mt-14">
          <Button
            bgColor={"bg-dark/30"}
            type="bgBtn"
            title="No, Proceed to payment"
            className="bg-dark/50 rounded-md p-3"
            onClick={handlePayment}
          />
          <Button
            bgColor={"bg-secondary"}
            textColor={"text-white"}
            type="bgBtn"
            title="Certainly! Yes, I'd like to register."
            onClick={handleClick}
          ></Button>
        </div>
      </div>
    </div>
  );
}
